const CreateGroupUser = `mutation createGroupUser($groupId: Int!, $username: String!){
  createGroupUser(groupId: $groupId, username: $username){
    groupUser{
      groupUserId
    }
  }
}`;

const DeleteGroupUser = `mutation deleteGroupUser($groupId: Int!, $username: String!){
  deleteGroupUser(groupId: $groupId, username: $username){
    response
  }
}`;

module.exports = {
  CREATE_GROUP_USER_MUTATION: CreateGroupUser,
  DELETE_GROUP_USER_MUTATION: DeleteGroupUser,
};
